module.exports = __webpack_public_path__ + "img/D201805_4.31c6f0e0.jpg";